// extracted by mini-css-extract-plugin
module.exports = {"container":"courseList_container__2Ew8u","name":"courseList_name__3dEAB"};